import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { CDN_PIVOT } from 'core/constants/endpoints'

function getResourceFromV2(path) {
  return fetchJSONHandleError({
    url: `${CDN_PIVOT}/resources/v2/${path}`
  })
}

export default getResourceFromV2
